import { render } from 'preact';
import * as Sentry from '@sentry/react';
import { IS_EYEJACK_APP } from '@webcore/core/utils/utils';
import { configureRuntime } from '@core/runtime/runtime';

import { AppLoadingOverlay } from './components/AppLoadingOverlay';
import { App } from './App';
import { getContentData, initializeContentData, resolveDeferredContentData } from './data/data';

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: 'https://d6211d89c6da60460e4f19c02630706d@o1388406.ingest.us.sentry.io/4510990051835904',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

const appElement = document.getElementById('app');

// App Clip: show loading overlay immediately
if (appElement && IS_EYEJACK_APP) {
  render(<AppLoadingOverlay />, appElement);
}

async function bootstrap(): Promise<void> {
  await initializeContentData();

  // Configure runtime loading
  // - App Clip: loads immediately (handled internally via IS_EYEJACK_APP)
  // - Web: prewarmed on component mount for instant XR
  configureRuntime({
    load: async () => {
      await resolveDeferredContentData();
      const { appReady } = await import('./main.app.immersal');
      await appReady;
    },
  });

  if (appElement) {
    render(<App contentData={getContentData()} />, appElement);
  }
}

bootstrap().catch((error) => {
  Sentry.captureException(error);
  throw error;
});
